module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("VueForm " + (_vm.componentParams.template))
  }, [(_vm.componentParams.template == "default" || !_vm.componentParams.template) ? _c('default', {
    attrs: {
      "data": _vm.api_response
    },
    on: {
      "SENDFORM": _vm.submit
    }
  }) : [_vm._v("\n\t\tUnknown form template "), _c('b', [_vm._v(_vm._s(_vm.componentParams.template))])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3528ec5d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/Form.vue
// module id = 247
// module chunks = 36